export default [
    {
        path: 'user',
        component: r => require.ensure([], () => r(require('@/views/protocol/user')), 'protocol'),
        meta: {
            title: '服务协议'
        }
    },
    {
        path: 'charge',
        component: r => require.ensure([], () => r(require('@/views/protocol/charge')), 'protocol'),
        meta: {
            title: '悠数学收费服务协议'
        }
    },
    {
        path: 'chargeios',
        component: r => require.ensure([], () => r(require('@/views/protocol/charge-ios')), 'protocolios'),
        meta: {
            title: '悠数学收费服务协议'
        }
    },
    {
        path: 'charge_for_ios',
        component: r => require.ensure([], () => r(require('@/views/protocol/charge-for-ios')), 'protocolios'),
        meta: {
            title: '悠数学隐私政策'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/protocol.js